<template>
    <div v-if="flow === 'A' || flow === 'B'" class="modal remind-onboarding">
        <vs-row vs-justify="center">
            <vs-col type="flex" vs-justify="center" vs-align="center">
                <vs-card :id="modalId" class="remind text-center">
                    <div slot="header">
                        <img :src="imgSrc" alt="Remind Onboarding" />
                    </div>
                    <div class="content">
                        <h5 class="font-bold text-xl mb-2">{{ title }}</h5>
                        <vs-list>
                            <div
                                v-for="(option, index) in options"
                                :key="index"
                                @click="!option.completed ? onSelect(option) : () => {}"
                                class="option-onboarding ml-4">
                                <img v-if="option.completed" :src="iconList.checked" alt="Remind Onboarding" />
                                <img v-else-if="!option.completed && option.checked" :src="iconList.selected" alt="Selected Onboarding" />
                                <img v-else :src="iconList.unchecked" alt="Remind Onboarding" />

                                <p
                                    class="text-lg cursor-pointer"
                                    :class="{
                                        'text-grey': option.completed,
                                        'text-primary': !option.completed,
                                    }">
                                    {{ option.text }}
                                </p>
                            </div>
                        </vs-list>

                    </div>
                    <div slot="footer">
                        <Button class="mb-4 w-full" @click="onContinue">Hướng dẫn tiếp theo</Button>
                        <Button @click="onSkip" class="mb-4 w-full vs-button--white" :color="'white'"
                            >Cảm ơn, tôi đã biết sử dụng rồi</Button
                        >
                    </div>
                </vs-card>
            </vs-col>
        </vs-row>
    </div>
    <div v-else></div>
</template>

<script>
import Button from '@/components/Button/Button.vue';
import userOnboardingService from '../../../core/services/userOnboardingService';

export default {
    name: 'remind-modal',

    components: {
        Button,
    },

    props: {
        isRemind: {
            type: Boolean,
            default: false,
        },

        options: {
            type: Array,
            default: () => [],
        },

        flow: {
            type: String,
            default: '',
        },

        loading: {
            type: Boolean,
            default: false,
        },

        modalId: {
            type: String,
            default: "remind-modal"
        }
    },

    data() {
        return {
            imgSrcList: {
                remind: require('@assets/images/user-onboarding/remind.png'),
                continue: require('@assets/images/user-onboarding/continue.png'),
            },
            titleList: {
                remind: 'Bạn chưa hoàn thành tất cả hướng dẫn. Tiếp tục nhé?',
                continue: 'Bạn đã hoàn tất hướng dẫn ',
            },
            iconList: {
                checked: require('@assets/images/user-onboarding/checked.svg'),
                unchecked: require('@assets/images/user-onboarding/unchecked.svg'),
                selected: require('@assets/images/user-onboarding/selected.svg'),
            },
        };
    },

    computed: {
        imgSrc() {
            return this.isRemind ? this.imgSrcList.remind : this.imgSrcList.continue;
        },

        title() {
            let title = '';

            if (this.isRemind) {
                title = this.titleList.remind;
            } else {
                let option = this.options.filter((item) => item.completed);
                title = this.titleList.continue + (option[0] ? `"${option[0].text}"` : '');
            }

            return title;
        }
    },

    watch: {
        loading() {
            this.$site.loading[this.loading ? 'open' : 'close']("#" + this.modalId);
        }
    },

    methods: {
        onContinue() {
            try {
                const tutorial = this.options.find(({ checked }) => checked);

                this.$emit('continue', { tutorial: tutorial.id, component: 'remind-modal' });
            } catch(e) {}
        },

        onSkip() {
            this.$emit('skip');
        },

        onSelect(option = null) {
            this.$emit('select', option);
        },

        onUnload() {
            userOnboardingService.closeReminder();
        },
    },

    mounted() {
        if(this.loading) {
            this.$site.loading.open("#" + this.modalId);
        }

        window.onbeforeunload = () => {
            return 'Are you sure to quit?';
        };

        window.onunload = this.onUnload;
    },

    beforeDestroy() {
        window.onbeforeunload = () => {};
        window.onunload = () => {};
    },
};
</script>

<style lang="scss">
.modal.remind-onboarding {
    position: fixed;
    z-index: 999999;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.3);

    .modal-content {
        margin: auto;
        display: block;
        width: 70%;
        -webkit-animation-name: zoom;
        -webkit-animation-duration: 0.6s;
        animation-name: zoom;
        animation-duration: 0.6s;
    }

    @-webkit-keyframes zoom {
        from {
            -webkit-transform: scale(0);
        }
        to {
            -webkit-transform: scale(1);
        }
    }

    @keyframes zoom {
        from {
            transform: scale(0);
        }
        to {
            transform: scale(1);
        }
    }

    @media only screen and (max-width: 768px) {
        .modal-content {
            width: 100%;
        }
    }
    .vs-col {
        width: auto;
        max-width: 378px;
    }
    .remind {
        .vs-card--header {
            padding: 20px 20px 16px 20px;
        }
        .vs-card--content {
            padding: 0 20px 8px 20px;
            margin-bottom: 0;
            background: #ffffff;
        }

        .vs-card--footer {
            padding: 0 20px 0 20px;
            transform: none;
            margin-top: 0;
        }

        .content {
            text-align: center;

            .option-onboarding {
                display: flex;
                align-items: center;
                img {
                    padding-right: 10px;
                    width: 26px;
                    height: 17px;
                }
            }

            .option-onboarding:nth-child(1) {
                margin-bottom: 10px;
            }

            .vs-list {
                padding: 10px 20px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/UserOnboarding/components/RemindModal.vue